<template>
    <Tree :data="tree"
        show-checkbox
        ref="authTree"></Tree>
</template>
<script type="text/javascript">
import { listToTree } from '_u/helper'

const WINDOW_HEIGHT = document.body.clientHeight
export default {
    props: {
        resTree: {
            type: [Array],
            require: true
        },
        orgAuth: {
            type: [Array],
            require: true
        },
    },
    data() {
        return {
            tree: []
        }
    },
    computed: {
        arrange() {
            return [{
                title: "岗位名称",
                key: "name",
                align: "left",
                render: anchorCell({
                    click: (row, column, index) => {
                        this.selectOrg(row)
                    }
                })
            }]
        }
    },
    methods: {
        //检测有没有修改 true 修改   false 未修改
        checkUpdate() {
            var ids = this.getResIds()
            var isHave = 0
            ids.forEach(v => {
                var auth = this.orgAuth.find(v1 => v1.resourceId == v)
                if (this.orgAuth.length > 0 && auth) {
                    isHave++
                }
            })
            if (isHave == this.orgAuth.length) {
                return false
            }
            return true
        },
        // 获取已选中的资源节点
        getResIds() {
            var ids = []
            this.$refs.authTree.flatState.forEach(v => {
                var data = v.node
                if (data.checked || data.indeterminate) {
                    ids.push(data.id)
                }
            })
            return ids
        },

        fillResources() {
            var resTree = this.resTree,
                orgAuth = this.orgAuth

            var authMap = {},
                resList = [],
                authTree = [],
                canUpdate = this.$can('update')

            // 数据预处理
            orgAuth.forEach(v => authMap[v] = true)
            resTree.sort((a, b) => a.sortNum - b.sortNum)
            resTree.forEach(v => {
                this.$set(v, "expand", true)
                resList.push(v)
            })
            authTree = listToTree(resList, { id: 'id', pId: 'pid', copy: false })
            resList.forEach(v => {
                // 权限控制
                if (canUpdate == false) {
                    v.disabled = true
                }

                // 展开功能节点
                if (v.type == 5 || v.type == 3) {
                    v.spread = true
                }

                // 已授权功能
                if ((v.isEnd || v.spread) && authMap[v.id]) {
                    this.$set(v, "checked", true)
                }
            })

            this.tree = authTree
        },
    },
    created() {
        this.fillResources()
    }
}
</script>